if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const formData = new FormData(this.form);
        console.log(formData.get('properties[_personalise]'), "formData.get('properties[_personalise]')");
        let personal_checkbox = this.closest('product-info')?.querySelector("#personalise-gloves");
        let checkbox_text = this.closest('product-info')?.querySelector("#personalise-gloves-text");

        if(personal_checkbox && personal_checkbox.checked != false) {
          if(personal_checkbox && personal_checkbox.value != "" && checkbox_text.value.trim() != "") {
            this.closest('product-info').querySelector('.personalise-gloves-wrapper span.error-message').classList.add('hide');
          } else {
            this.closest('product-info').querySelector('.personalise-gloves-wrapper span.error-message').classList.remove('hide');
            this.closest('product-info').querySelector('.personalise-gloves-wrapper span.error-message').scrollIntoView({ behavior: 'smooth', block: 'start' });
            const errorMessage = this.closest('product-info').querySelector('.personalise-gloves-wrapper span.error-message');
            if (errorMessage) {
                const rect = errorMessage.getBoundingClientRect();
                const scrollTop = document.documentElement.scrollTop;
                window.scrollTo({
                    top: rect.top + scrollTop - 100,
                    behavior: 'smooth'
                });
            }
            return;
          }
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
        if (this.cart) {
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        var item = {};
        item.properties = {}
        formData.forEach(function(value, key){
          if (key.includes('properties[')) {
            key = key.replace("properties[", "").replace("]", "")
            value ? item.properties[key] = value : ''
          } else {
            item[key] = value;
          }
        });
        var items = []
        items.push(item);
        let personalise_checkbox = document.getElementById("personalise-gloves");
        if(personalise_checkbox && personalise_checkbox.checked != false) {
          items.push({
            quantity: 1,
            id: parseInt(document.querySelector('[name="_personalise_product"]').value),
            properties: item.properties
          });
        }

        const body = JSON.stringify({
          items,
          sections: sections,
          sections_url: window.location.pathname
        }); 


        fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
            },
            body: body
          })
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}




class PdpSticky extends HTMLElement {
  constructor() {
    super();
    this.productMain = document.querySelector('product-info')
    this.targetButton = this.productMain.querySelector('.price-per-item__container');
    const initialvariantSelevcted = this.querySelector('input[name="Size"]:checked');
    this.optselector = this.querySelector('details');
    this.variantSelect = this.querySelector('variant-selects');
    this.checkScrollPosition();
    window.addEventListener('scroll', this.checkScrollPosition.bind(this));
    this.variantSelect.addEventListener('change', this.changeVariant.bind(this)); 
    this.querySelector('.button-text').textContent = initialvariantSelevcted.value;
  }
  

  checkScrollPosition() {
    let targetButtonOffset = this.targetButton.getBoundingClientRect().top + window.scrollY;
    let scrollTop = window.scrollY;

    if (scrollTop > targetButtonOffset) {
        this.classList.add('show_sticky');
    } else {
        this.classList.remove('show_sticky');
    }
  }
  changeVariant() {
    this.optselector.removeAttribute('open')
    const selectedVariant = this.variantSelect.querySelector('input[name="Size"]:checked');
    if (selectedVariant) {
      const variantName = selectedVariant.value;
      this.optselector.querySelector('.button-text').textContent = variantName;
    }
  }
}
customElements.define('product-sticky-form', PdpSticky);
